import { Box, Image, Stack, Text, VStack } from "@chakra-ui/react";
import { FaArrowLeft, FaArrowRight, FaRegCirclePlay } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Logo from "../../../assets/colorLogo.png";

const Teachers = ({ link = "/teacher", selectedDepartment = null }) => {
  const { teachers } = useSelector((state) => state.public);
  const baseUrl = "https://api.agwad.net/";
  const navigate = useNavigate();
  const filteredTeachers =
    selectedDepartment === null || selectedDepartment === undefined
      ? teachers
      : teachers?.filter((teacher) => teacher?.department == selectedDepartment);

  function SampleNextArrow(props) {
    const { style, onClick } = props;
    return (
      <div
        style={{
          ...style,
          display: "block",
          width: "30px",
          right: "-35px",
          position: "absolute",
          top: "0",
          zIndex: "10000000",
          height: "92%",
          background: "#f2f2f2",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          opacity: "70%",
        }}
        onClick={onClick}
      >
        <FaArrowRight size={22} />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { style, onClick } = props;
    return (
      <div
        style={{
          ...style,
          display: "block",
          width: "30px",
          position: "absolute",
          left: "-35px",
          top: "0%",
          zIndex: "10000000",
          height: "92%",
          background: "#f2f2f2",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          opacity: "70%",
        }}
        onClick={onClick}
      >
        <FaArrowLeft size={22} />
      </div>
    );
  }

  const settings = {
    dots: true,
    infinite: filteredTeachers?.length < 3 ? false : true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    variableWidth: true,
    appendDots: (dots) => (
      <div
        style={{
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={{
          width: "16px",
          height: "16px",
          background: "#8196df",
          borderRadius: "50%",
        }}
      ></div>
    ),
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <VStack
      id="teachers-section"
      gap={{ base: 4, md: 6 }}
      h="100%"
      w="100%"
      alignItems="flex-start"
      my={{ base: 20, md: 32, lg: 40 }}
    >
      <Text
        fontSize={{ base: "24px", md: "28px", lg: "32px" }}
        color="main_1"
        textAlign="center"
        fontWeight="700"
        textTransform="uppercase"
        w="100%"
        px={{ base: 2, md: 0 }}
      >
        Teachers
      </Text>
      <Box w="100%" px={{ base: 2, md: 0 }}>
        {filteredTeachers?.length ? (
        <Slider {...settings} key={selectedDepartment} className="slider">
          {filteredTeachers?.map((data, index) => {
            return (
              <Box
                key={index}
                w={{
                  base: "280px !important",
                  md: "320px !important",
                  lg: "350px !important",
                }}
                bg="blackAlpha.200"
                borderRadius={16}
                display="flex !important"
                flexDirection="column"
                onClick={() => navigate(`${link}/${data?.id}`)}
                role="group"
                cursor="pointer"
                mx={{ base: 1, md: 2 }}
                _hover={{
                  transition: "500ms ease-in-out",
                  transform: "translateY(-5px)",
                  boxShadow: "lg",
                }}
              >
                <Box overflow="hidden">
                  <Image
                    h={{ base: "200px", md: "220px", lg: "250px" }}
                    w="100%"
                    src={
                      data?.profile_picture
                        ? `${baseUrl}${data?.profile_picture}`
                        : Logo
                    }
                    alt="Teacher profile"
                    borderTopRadius="lg"
                    objectFit="fill"
                    bgPos="top"
                    _groupHover={{
                      transform: "scale(1.1)",
                      transition: "500ms ease-in-out",
                    }}
                  />
                </Box>
                <Stack spacing="2" p={{ base: 3, md: 4, lg: 5 }}>
                  <Text
                    color="main_1"
                    fontSize={{ base: 16, md: 18, lg: 20 }}
                    fontWeight={600}
                    noOfLines={1}
                  >
                    {data?.name}
                  </Text>
                  <Text
                    color="main_1"
                    fontSize={{ base: 14, md: 15, lg: 16 }}
                    noOfLines={1}
                  >
                    {data?.subjects?.[0]?.name}
                  </Text>

                  <Stack flexDirection="row" alignItems="center" gap={2}>
                    <FaRegCirclePlay color="#8196df" size={20} />
                    <Text
                      mt="-1px !important"
                      fontSize={{ base: 12, md: 14, lg: 16 }}
                    >
                      {data?.courses?.length} Course
                      {data?.courses?.length > 1 ? "s" : ""}
                    </Text>
                  </Stack>
                </Stack>
              </Box>
            );
          })}
        </Slider>
        ) : (
          <Text w="100%" textAlign="center" color="gray.500" py={8}>
            No teachers found for this department
          </Text>
        )}
      </Box>
    </VStack>
  );
};

export default Teachers;
